<template>
  <base-modal
    :closeable-from-outside="false"
    hide-footer
    :size="'lg'"
    :modal-id="'round-modal'"
    @hidden="$emit('onCloseModal')"
  >
    <template>
      <div class="head-label">
        <span>{{
          isEdit ? "Edit Round and Reward" : "Create Round and Reward"
        }}</span>
      </div>
    </template>
    <template>
      <b-form @submit.prevent="onSubmitRoundReward">
        <div class="row">
          <!-- test carousel-->

          <div class="col-4 bg-left p-0">
            <div class="pl-2 pr-2">
              <div class="font-medium-5 font-weight-bolder text-black mt-1">
                Round Information
              </div>
              <div class="row">
                <div class="col-md-12 mt-2">
                  <div class="row">
                    <div class="col-12">
                      <div class="d-flex">
                        <span class="status-toggle font-medium-5"
                          >{{ "Status" }}
                        </span>
                        <b-form-checkbox
                          fieldValue="true"
                          class="custom-control-success ml-4"
                          name="check-button"
                          switch
                          v-model="formData.round.status"
                        >
                        </b-form-checkbox>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <b-form-group
                        :label="'Round Name (Thai)'"
                        label-for="round-name"
                        label-class="font-medium-5 required"
                      >
                        <b-form-input
                          id="round-name"
                          v-model="formData.round.nameTh"
                          placeholder="ระบุ"
                          required
                        />
                      </b-form-group>
                    </div>
                    <div class="col-12">
                      <b-form-group
                        :label="'Round Name (English)'"
                        label-for="round-name"
                        label-class="font-medium-5"
                      >
                        <b-form-input
                          id="round-name"
                          v-model="formData.round.nameEn"
                          placeholder="ระบุ"
                        />
                      </b-form-group>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="border-b-left"></div>

            <div class="pl-2 pr-2">
              <span class="font-medium-5">Duration</span>

              <b-row id="Valid-date">
                <b-col cols="12">
                  <div class="d-flex">
                    <div class="p-0 p-relative mr-2">
                      <b-form-group
                        :label="'Valid From'"
                        label-for="campagin-name"
                        label-class="title-name font-medium-4 mt-2 required"
                      >
                        <div
                          @mouseenter="onHoverValidFromDay(true)"
                          @mouseleave="onHoverValidFromDay(false)"
                        >
                          <flat-pickr
                            required
                            v-if="!formData.isHoverValidFrom"
                            :id="'valid-from-date'"
                            v-model="formData.validFrom.date"
                            class="form-control bg-date"
                            :class="
                              formData.validFrom.date ? 'date-selected' : null
                            "
                            :config="ConfigflatpickrDateValidFrom"
                            placeholder="Select Date"
                            autocomplete="off"
                            @on-change="
                              getNumberValidFrom(
                                formDataObj.validFrom.date,
                                formData.validFrom.date
                              )
                            "
                          ></flat-pickr>
                          <flat-pickr
                            v-else
                            required
                            :id="'valid-through-date'"
                            v-model="formData.dataNull"
                            class="form-control bg-date"
                            :class="
                              formData.validThrough.date
                                ? 'date-selected'
                                : null
                            "
                            :config="ConfigflatpickrDateValidFrom"
                            autocomplete="off"
                            @on-change="
                              getNumberValidFrom(
                                formDataObj.validFrom.date,
                                formData.validFrom.date
                              )
                            "
                          ></flat-pickr>
                          <calendar-picker-icon
                            class="icon-calendar bypass"
                            :class="
                              formData.validFrom.date
                                ? 'date-selected-icon'
                                : null
                            "
                          />
                          <div
                            class="hover-day elli-text-date"
                            v-if="formData.isHoverValidFrom"
                          >
                            {{
                              `Last ${
                                formData.calValidFromDate <= 0
                                  ? 0
                                  : formData.calValidFromDate
                              } Day`
                            }}
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="p-0 p-relative">
                      <b-form-group
                        :label="'Time'"
                        label-for="campagin-name"
                        label-class="title-name font-medium-4 mt-2 required"
                      >
                        <flat-pickr
                          required
                          id="valid-from-time"
                          v-model="formData.validFrom.time"
                          class="form-control bg-date"
                          :class="
                            formData.validFrom.time ? 'date-selected' : null
                          "
                          :config="flatpickrTimeConfig"
                          :placeholder="'Select Time'"
                          autocomplete="off"
                          @on-change="
                            () => {
                              if (
                                formData.validFrom.date ==
                                  formData.validThrough.date &&
                                formData.validFrom.time >
                                  formData.validThrough.time
                              ) {
                                formData.validThrough.time = null;
                              }
                            }
                          "
                        />

                        <clock-picker-icon
                          class="icon-calendar date-picker-icon bypass"
                          :class="
                            formData.validFrom.time
                              ? 'date-selected-icon'
                              : null
                          "
                        />
                      </b-form-group>
                    </div>
                  </div>
                </b-col>
                <b-col cols="12">
                  <div class="d-flex">
                    <div class="p-0 p-relative mr-2">
                      <b-form-group
                        :label="'Valid Through'"
                        label-for="campagin-name"
                        label-class="title-name font-medium-4 mt-2 required"
                      >
                        <div
                          @mouseenter="onHoverValidThrough(true)"
                          @mouseleave="onHoverValidThrough(false)"
                        >
                          <flat-pickr
                            v-if="!formData.isHoverValidThrough"
                            required
                            :id="'valid-through-date'"
                            v-model="formData.validThrough.date"
                            class="form-control bg-date"
                            :class="
                              formData.validThrough.date
                                ? 'date-selected'
                                : null
                            "
                            :config="ConfigflatpickrValidThrough"
                            placeholder="Select Date"
                            autocomplete="off"
                            @on-change="
                              getNumberValidThrough(
                                formDataObj.validThrough.date,
                                formData.validThrough.date
                              )
                            "
                          />

                          <flat-pickr
                            v-else
                            required
                            :id="'valid-through-date'"
                            v-model="formData.dataNull"
                            class="form-control bg-date"
                            :class="
                              formData.validThrough.date
                                ? 'date-selected'
                                : null
                            "
                            :config="ConfigflatpickrValidThrough"
                            autocomplete="off"
                            @on-change="
                              getNumberValidThrough(
                                formDataObj.validThrough.date,
                                formData.validThrough.date
                              )
                            "
                          />
                          <calendar-picker-icon
                            class="icon-calendar bypass"
                            :class="
                              formData.validThrough.date
                                ? 'date-selected-icon'
                                : null
                            "
                          />

                          <div
                            class="hover-day elli-text-date"
                            v-if="formData.isHoverValidThrough"
                          >
                            {{
                              `Last ${
                                formData.calValidThroughDate <= 0
                                  ? 0
                                  : formData.calValidThroughDate
                              } Day`
                            }}
                          </div>
                        </div>
                      </b-form-group>
                    </div>

                    <div class="p-0 p-relative">
                      <b-form-group
                        :label="'Time'"
                        label-for="campagin-name"
                        label-class="title-name font-medium-4 mt-2 required"
                      >
                        <flat-pickr
                          required
                          id="valid-from-time"
                          v-model="formData.validThrough.time"
                          class="form-control bg-date"
                          :class="
                            formData.validThrough.time ? 'date-selected' : null
                          "
                          :config="flatpickrTimeConfig"
                          :placeholder="'Select Time'"
                          autocomplete="off"
                          @on-open="
                            () => {
                              if (
                                formData.validFrom.date ==
                                formData.validThrough.date
                              ) {
                                flatpickrTimeConfig.minTime =
                                  formData.validFrom.time;
                              }
                            }
                          "
                        />

                        <clock-picker-icon
                          class="icon-calendar date-picker-icon bypass"
                          :class="
                            formData.validThrough.time
                              ? 'date-selected-icon'
                              : null
                          "
                        />
                      </b-form-group>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="col-8 bg-right pl-2">
            <div class="row pl-2 pr-2" id="col-right-reward">
              <div class="col mb-2 pl-0 mt-1">
                <span class="font-medium-5 font-weight-bolder text-black"
                  >Reward and Winner</span
                >

                <!-- form -->
                <div
                  class="d-flex mt-1 align-item-center w-overflow prevent-select"
                >
                  <div
                    id="target"
                    class="tab-change"
                    :class="[formData.isOverflowed ? 'w-100per' : null]"
                    ref="overflowTabReward"
                    @mousedown="mousedownScroll"
                    @mouseleave="mouseleaveScroll"
                    @mouseup="mouseupScroll"
                    @mousemove="mousemoveScroll"
                  >
                    <draggable
                      :componentData="componentData"
                      :animation="100"
                      handle=".handle"
                      @start="reorderRewardStart"
                      @end="reorderRewardFunc"
                      item-key="name"
                      class="d-flex custom-padding"
                      ghost-class="ghost"
                    >
                      <div
                        class="mr-4 cursor-cm bg-hover"
                        v-for="(element, idx) in formData.rewardItem.payload"
                        :key="idx"
                        :class="[
                          element.id == formData.activeIndex
                            ? 'bg'
                            : 'bg-hover',
                          idx === 0
                            ? formData.activeTab
                              ? element.id == formData.activeIndex
                                ? 'bg'
                                : 'bg-hover'
                              : ''
                            : '',
                        ]"
                        @click="toggleActive(element)"
                        @mouseenter="onHover(element.id, true)"
                        @mouseleave="onHover(element.id, false)"
                        v-b-tooltip.hover="{
                          title: `${element.title}`,
                          placement: 'top',
                          variant: 'secondary',
                        }"
                      >
                        <button
                          type="button"
                          @click="() => {}"
                          class="custom-btn-reorder cusor-reorder"
                          @mousedown="onClickReorder(element)"
                        >
                          <icon-reorder
                            class="mr-2 handle "
                            v-if="
                              element.id == formData.activeIndex ||
                                (formData.isHover &&
                                  element.id == formData.hoverIndex) ||
                                (idx == 0 ? formData.activeTab : '')
                            "
                          />
                        </button>

                        <span
                          class="font-medium-4 mr-1 elli-text cursor-scroll"
                          @mousedown="onClickScroll(element)"
                          >{{ element.title }}</span
                        >
                        <div
                          class="custom-edit-icon"
                          @click="onOpenModalReward(element)"
                        >
                          <edit-icon
                            class="ml-2 mr-2 svg-icon"
                            v-if="
                              formData.isHover &&
                                element.id == formData.hoverIndex
                            "
                          />
                        </div>
                        <div
                          class="custom-edit-icon active"
                          @click="onRemoveReward(element)"
                        >
                          <delete-icon
                            class="ml-2 mr-2 svg-icon"
                            v-if="
                              formData.isHover &&
                                element.id == formData.hoverIndex
                            "
                          />
                        </div>
                      </div>
                    </draggable>
                  </div>

                  <div class="d-flex align-item-center">
                    <div class="mr-1 ml-1 custom-scroll-icon">
                      <b-dropdown
                        size="lg"
                        variant="link"
                        no-caret
                        right
                        toggle-class="p-0 mr-1"
                        class="action-dropdown"
                        ref="overflowDropdown"
                        v-if="formData.isOverflowed"
                      >
                        <template #button-content>
                          <b-button
                            @click="changeActive"
                            :class="{ 'active-scroll': formData.activeClass }"
                            variant="secondary"
                            class="action-dropdown-scroll"
                          >
                            <icon-scroll class="svg-icon-scroll" />
                          </b-button>
                        </template>
                        <b-dropdown-item
                          v-for="option in formData.rewardItem.payload"
                          :key="option.id"
                          :value="option.id"
                          @click="toggleActive(option)"
                        >
                          {{ option.title }}</b-dropdown-item
                        >
                      </b-dropdown>
                    </div>
                    <div class="">
                      <b-button
                        size="sm"
                        @click="addReward"
                        id="tooltip-btn"
                        class="tooltip-btn"
                        variant="primary"
                        v-b-tooltip.hover="{
                          title: 'Add Reward',
                          placement: 'top',
                          variant: 'secondary',
                        }"
                      >
                        <add-icon class="icon-add-reward"
                      /></b-button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 mb-2">
                <div
                  v-for="(elem, inx) in formData.rewardItem.payload"
                  :key="'detail' + inx"
                >
                  <div
                    class="row border-b"
                    v-if="elem.id == formData.activeIndex"
                  >
                    <div class="col-6 pl-0">
                      <div class="d-flex">
                        <span class="status-toggle font-medium-5"
                          >{{ "Status" }}
                        </span>
                        <b-form-checkbox
                          field-value="true"
                          class="custom-control-success ml-4"
                          name="check-button"
                          switch
                          :checked="elem.status == 1 ? true : false"
                          @change="onToggleStatus($event, elem)"
                        >
                        </b-form-checkbox>
                      </div>

                      <b-form-group
                        :label="'Reward Name (Thai)'"
                        label-for="campagin-name"
                        label-class="font-medium-5 required"
                      >
                        <b-form-input
                          id="reward-name"
                          v-model="elem.name"
                          placeholder="ระบุ"
                          required
                        />
                      </b-form-group>

                      <b-form-group
                        :label="'Reward Value'"
                        label-for="reward-name"
                        label-class="font-medium-5 required"
                      >
                        <b-form-input
                          id="campaign-name"
                          v-model="elem.value"
                          placeholder="0"
                          required
                          :formatter="formatterValue"
                        />
                      </b-form-group>
                    </div>
                    <div class="col-6">
                      <div class="font-medium-4">
                        <span class="mr-2">Image</span>
                        <span class="desc-title"
                          >(Format JPG, JPEG, PNG Max 2 Mb)</span
                        >
                      </div>
                      <image-upload
                        :removable="true"
                        :image-url="elem.url"
                        @onUpload="onUploadMainImg($event, elem)"
                      />
                    </div>
                  </div>
                </div>

                <div
                  class="row mt-2 mb-2"
                  v-if="formData.rewardItem.payload.length > 0"
                >
                  <div>
                    <p class="font-medium-5 font-weight-bolder text-black m-0">
                      Winner list
                    </p>
                    <div class="d-flex">
                      <span class="text-sub">
                        Download template to upload your winner list, make sure
                        your file is ready to be imported.
                      </span>

                      <div class="text-down ml-2" @click="onDownloadTemplate">
                        <!-- รอ icon download -->
                        <download-icon class="mr-2 fill-icondown" />

                        <span>ดาวน์โหลดเทมเพลต</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row" v-if="formData.rewardItem.payload.length > 0">
                  <div
                    class="col"
                    v-for="(ele, inx) in formData.rewardItem.payload"
                    :key="'status' + inx"
                    :class="ele.id != formData.activeIndex ? 'd-none' : ''"
                  >
                    <div
                      class="row d-flex justify-content-between align-item-center"
                      v-if="ele.id == formData.activeIndex"
                    >
                      <div class="d-flex">
                        <span class="status-toggle font-medium-5"
                          >{{ "Status" }}
                        </span>
                        <b-form-checkbox
                          fieldValue="true"
                          class="custom-control-success ml-4"
                          name="check-button"
                          switch
                          v-model="ele.isdisplay_winner"
                        >
                        </b-form-checkbox>
                      </div>

                      <div class="d-flex">
                        <b-button
                          :class="{ 'btn-action': hasSelectWinner }"
                          class="btn-winner"
                          variant="outline-dark"
                          v-if="hasSelectDel"
                          @click="onRemoveWinner"
                          :disabled="!hasSelectWinner"
                        >
                          <delete-icon
                            class="fill-icon"
                            :class="{ 'fill-icon-action': hasSelectWinner }"
                        /></b-button>

                        <lucky-draw-button
                          class="ml-1 mr-1"
                          @click.native="openWinnerModal"
                          :btn-label="'Winner'"
                          :isShowIconAdd="true"
                        />

                        <b-form-file
                          v-model="formData.winner.file"
                          ref="fileInput"
                          class="d-none"
                          plain
                          :accept="acceptFile.toString()"
                          @input="onInputFile"
                        ></b-form-file>

                        <lucky-draw-button
                          class="ml-1 mr-1"
                          @click.native="onUploadFile"
                          :btn-label="'Upload Winner List'"
                          :isShowIconDown="true"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="row mt-1"
                  v-for="(ele, inx) in formData.rewardItem.payload"
                  :key="'table' + inx"
                  :class="ele.id != formData.activeIndex ? 'd-none' : ''"
                >
                  <b-col
                    cols="12"
                    class="mb-1 p-0"
                    v-if="ele.id == formData.activeIndex"
                  >
                    <overlay-loading :loading="loading.tableData">
                      <template #content>
                        <b-table
                          :key="tableModeReorder + keyChange"
                          :fields="fields"
                          :items="ele.winnerListTable"
                          v-sortable-row="sortableRowOptions"
                          responsive
                          bordered
                          borderless
                          sticky-header
                          show-empty
                          no-local-sorting
                          :busy="loading.uploadfile"
                          class="default-static-table"
                        >
                          <!-- select All-->
                          <template #head(selected)>
                            <div class="d-flex justify-content-end">
                              <b-form-checkbox
                                class="custom-control-success d-flex align-items-center"
                                v-model="formData.isSelectAll"
                                @change="selectAllWinner($event, ele.id)"
                              >
                              </b-form-checkbox>
                            </div>
                          </template>

                          <template #cell(selected)="data">
                            <div class="layout-icon-reorder">
                              <icon-reorder
                                class="handle icon-reorder-table"
                                :class="
                                  tableModeReorder ? 'table-reorder' : null
                                "
                              />

                              <input
                                type="checkbox"
                                class="d-flex ml-3 checkbox-table custom-input-checkbox"
                                v-model="formData.selectedArr"
                                :value="data.item.winnerid"
                                @change="selectItemWinner()"
                              />
                            </div>
                          </template>
                          <template #head(seq)="data">
                            <div class="text-center">
                              {{ data.label }}
                            </div>
                          </template>

                          <template #table-busy>
                            <upload-excel-loading
                              :formData="formData.uploadLoading"
                              :isUpload="loading.uploadfile"
                              @onUpdateProgress="onUpdateProgress"
                            />
                          </template>
                          <template #empty>
                            <content-no-item
                              v-if="
                                !loading.uploadfile ||
                                  formData.uploadLoading.value == 100
                              "
                              :textNoImg="'Upload Winner List'"
                              :actionFunc="onUploadFile"
                              :isShowIconDown="true"
                            />
                          </template>
                        </b-table>
                      </template>
                    </overlay-loading>
                  </b-col>
                </div>
                <div
                  class="d-flex justify-content-center"
                  v-if="formData.rewardItem.payload.length <= 0"
                >
                  <img
                    src="~@/assets/images/artwork/no-item.png"
                    alt=""
                    height="350px"
                  />
                </div>
              </div>
            </div>
            <div class="row p-absolute p-left">
              <div class="privilege-btn-wrp mt-2 mb-2">
                <div class="d-flex justify-content-center">
                  <cancel-button
                    class="mr-2"
                    :btnLabel="'Back'"
                    :stageBack="true"
                    @click.native="$emit('onCloseModal')"
                  />
                  <save-button type="submit" class="ml-1" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </template>

    <create-winner-modal
      v-if="modalType.winner"
      @onSubmitWinnerModal="onSubmitWinnerModal"
      @onCloseModal="onCloseModalWinner"
    />

    <reward-modal
      v-if="modalType.reward"
      :formDataObj="formData"
      @onSubmitRewardModal="onSubmitRewardModal"
      @onCloseModal="onCloseModalReward"
    />
  </base-modal>
</template>

<script>
import {
  BCarousel,
  BCarouselSlide,
  BButton,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import BaseModal from "@/@core/components/base-modal/BaseModal.vue";
import { reactive, ref, getCurrentInstance } from "@vue/composition-api";
import CalendarPickerIcon from "@/@core/components/svg/common/CalendarPicker2.vue";
import ClockPickerIcon from "@/@core/components/svg/common/ClockPicker.vue";
import flatPickr from "vue-flatpickr-component";
import useFlatPickr from "@/utils/hooks/useFlatPickr";
import useRoundAndRewardModal from "./hooks/useRoundAndRewardModal";
import draggable from "vuedraggable";
import IconReorder from "@/@core/components/svg/common/IconReorder.vue";
import EditIcon from "@/@core/components/svg/common/IconEditWinner.vue";
import IconScroll from "@/@core/components/svg/common/IconScroll.vue";
import DeleteIcon from "@/@core/components/svg/common/Trash2.vue";
import ImageUpload from "@/views/components/image-upload/ImageUpload.vue";
import ContentNoItem from "@/@core/components/card-no-item/ContentNoItemLuckyDraw.vue";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import AddIcon from "@/@core/components/svg/common/IconPlus.vue";
import CreateWinnerModal from "./CreateWinnerModal.vue";
import RewardModal from "./RewardModal.vue";
import LuckyDrawButton from "@/views/components/button/LuckyDrawButton.vue";
import UploadExcelLoading from "@/views/components/loading/UploadExcelLoading.vue";
import DownloadIcon from "@/@core/components/svg/common/IconDownloadWinner.vue";
import Sortable from "sortablejs";

const createSortable = (el, options, vnode) =>
  Sortable.create(el, {
    ...options,
  });

const sortableRow = {
  name: "sortableRow",
  bind(el, binding, vnode) {
    const table = el;
    table._sortable = createSortable(
      table.querySelector("tbody"),
      binding.value,
      vnode
    );
  },
};
export default {
  directives: {
    sortableRow,
  },
  components: {
    BButton,
    BDropdown,
    BDropdownItem,
    BaseModal,
    CalendarPickerIcon,
    ClockPickerIcon,
    flatPickr,
    draggable,
    IconReorder,
    EditIcon,
    DeleteIcon,
    ImageUpload,
    ContentNoItem,
    PaginationWithReorder,
    AddIcon,
    CreateWinnerModal,
    RewardModal,
    LuckyDrawButton,
    UploadExcelLoading,
    BCarousel,
    BCarouselSlide,
    DownloadIcon,
    IconScroll,
  },
  props: {
    isEdit: { type: Boolean, default: false },
    formDataObj: { type: Object, default: null },
  },
  setup(props) {
    const vm = getCurrentInstance().proxy;

    const componentData = reactive({
      type: "transition",
      name: "flip-list",
    });

    const {
      formData,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      toggleActive,
      onHover,
      onUploadMainImg,
      loading,
      pagination,
      fields,
      onFilterEntity,
      onPageChange,
      hasSelectWinner,
      selectAllWinner,
      modalType,
      onCloseModalWinner,
      openWinnerModal,
      onInputFile,
      onUploadFile,
      acceptFile,
      onDownloadTemplate,
      onOpenModalReward,
      onCloseModalReward,
      sortableRowOptions,
      keyChange,
      tableModeReorder,
      addReward,
      onSubmitRoundReward,
      onRemoveReward,
      mousedownScroll,
      mouseleaveScroll,
      mouseupScroll,
      mousemoveScroll,
      onSubmitWinnerModal,
      onSubmitRewardModal,
      changeActive,
      onHoverValidFromDay,
      onHoverValidThrough,
      getNumberValidFrom,
      getNumberValidThrough,
      onRemoveWinner,
      selectItemWinner,
      reorderRewardFunc,
      onUpdateProgress,
      onToggleStatus,
      hasSelectDel,
      formatterValue,
      ConfigflatpickrDateValidFrom,
      ConfigflatpickrValidThrough,
      resolveDate,
      resolveTime,
      reorderRewardStart,
      onClickReorder,
      onClickScroll,
    } = useRoundAndRewardModal(props);

    return {
      formData,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      toggleActive,
      componentData,
      onHover,
      onUploadMainImg,
      loading,
      pagination,
      fields,
      onFilterEntity,
      onPageChange,
      hasSelectWinner,
      selectAllWinner,
      modalType,
      onCloseModalWinner,
      openWinnerModal,
      onInputFile,
      onUploadFile,
      acceptFile,
      onDownloadTemplate,
      onOpenModalReward,
      onCloseModalReward,
      sortableRowOptions,
      keyChange,
      tableModeReorder,
      addReward,
      onSubmitRoundReward,
      onRemoveReward,
      mousedownScroll,
      mouseleaveScroll,
      mouseupScroll,
      mousemoveScroll,
      onSubmitWinnerModal,
      onSubmitRewardModal,
      changeActive,
      onHoverValidFromDay,
      onHoverValidThrough,
      getNumberValidFrom,
      getNumberValidThrough,
      onRemoveWinner,
      selectItemWinner,
      reorderRewardFunc,
      onUpdateProgress,
      onToggleStatus,
      hasSelectDel,
      formatterValue,
      ConfigflatpickrDateValidFrom,
      ConfigflatpickrValidThrough,
      resolveDate,
      resolveTime,
      reorderRewardStart,
      onClickReorder,
      onClickScroll,
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style>
@import "~@/assets/css/pages/lucky-draw/round-modal.css";

#round-modal .elli-text {
  white-space: nowrap;
  width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media only screen and (max-width: 900px) and (min-width: 576px) {
  #round-modal .elli-text-date {
    white-space: nowrap;
    width: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

#round-modal .tab-change .cusor-reorder:hover {
  overflow-x: unset;
}

#target {
  touch-action: pan-x;
}
</style>

<style scoped>
.custom-btn-reorder {
  padding: 0;
  border: none;
  border-radius: unset;
  border-color: unset !important;
  background-color: unset !important;
}

.cursor-scroll {
  cursor: all-scroll;
}

.prevent-select {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}
</style>
